import React from "react";

export default function SectionHeading({ overline, title, subtitle, align = "left", className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`${alignCls} ${className} max-w-3xl`}>
      {overline && (
        <p className="text-xs md:text-sm uppercase tracking-[0.28em] text-sage font-medium mb-5">
          <span className="gold-divider mr-3" />
          {overline}
        </p>
      )}
      <h2 className="font-heading text-3xl md:text-5xl text-navy leading-tight tracking-tight text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base md:text-lg text-charcoal/80 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
